/* eslint-disable no-undef */

document.addEventListener('DOMContentLoaded', () => {
  const script = document.createElement('script');
  script.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
  script.async = true;
  script.onload = function () {
    loadAds(); // wordt gegarandeerd pas uitgevoerd na laden
  };
  document.head.appendChild(script);
});

window.googletag = window.googletag || { cmd: [] };

/*
 * Smart refresh (FD-1755)
 * Refresht ieder GPT-slot 30 seconden nadat de impressie viewable is,
 * alleen als de tab actief is en het slot minimaal 50% in beeld staat.
 * Maximaal 5 refreshes per slot per pageview.
 * Staat in de queue vóór loadAds(), dus listeners zijn er vóór enableServices().
 *
 * QA in de console: gardenersworldAdRefresh.status()
 */
googletag.cmd.push(installSmartRefresh);

function installSmartRefresh() {
  const pubads = googletag.pubads();

  const CONFIG = {
    intervalMs: 30000,
    minInViewPercentage: 50,
    maxRefreshesPerSlot: 5,
    // GAM line item IDs die niet mogen refreshen, bijv. new Set([123456789])
    blockedLineItemIds: new Set([]),
  };

  // Geen GPT-refresh bij terugkeer via bfcache, zodat alle refreshes via deze controller lopen
  googletag.setConfig({
    autoRefresh: {
      backForwardCache: false,
    },
  });

  const states = new Map();

  function slotName(slot) {
    return slot.getSlotElementId() || slot.getAdUnitPath();
  }

  function getState(slot) {
    if (!states.has(slot)) {
      states.set(slot, {
        refreshCount: 0,
        inViewPercentage: 0,
        eligibleAt: 0,
        armed: false,
        blockedCurrentCreative: false,
        currentLineItemId: null,
        timerId: null,
      });
    }

    return states.get(slot);
  }

  function clearTimer(slot) {
    const state = getState(slot);

    if (state.timerId !== null) {
      window.clearTimeout(state.timerId);
      state.timerId = null;
    }
  }

  function scheduleAttempt(slot, delayMs) {
    const state = getState(slot);

    clearTimer(slot);

    state.timerId = window.setTimeout(() => {
      state.timerId = null;
      attemptRefresh(slot);
    }, Math.max(0, delayMs));
  }

  function attemptRefresh(slot) {
    const state = getState(slot);

    if (!state.armed) {
      return;
    }

    // Slot is vernietigd (destroySlots)
    if (!pubads.getSlots().includes(slot)) {
      clearTimer(slot);
      states.delete(slot);
      return;
    }

    if (state.refreshCount >= CONFIG.maxRefreshesPerSlot) {
      state.armed = false;
      clearTimer(slot);
      return;
    }

    if (state.blockedCurrentCreative) {
      state.armed = false;
      clearTimer(slot);
      return;
    }

    const remainingMs = state.eligibleAt - Date.now();

    if (remainingMs > 0) {
      scheduleAttempt(slot, remainingMs);
      return;
    }

    if (document.visibilityState !== 'visible') {
      return;
    }

    if (state.inViewPercentage < CONFIG.minInViewPercentage) {
      return;
    }

    // Eerst disarmen, zodat dezelfde impressie nooit twee refreshes veroorzaakt
    state.armed = false;
    clearTimer(slot);
    state.refreshCount += 1;

    pubads.refresh([slot]);
  }

  // Line item van de huidige creative bewaren voor de blocklist
  pubads.addEventListener('slotRenderEnded', (event) => {
    const { slot } = event;
    const state = getState(slot);

    state.currentLineItemId = typeof event.lineItemId === 'number' ? event.lineItemId : null;
    state.blockedCurrentCreative = state.currentLineItemId !== null
      && CONFIG.blockedLineItemIds.has(state.currentLineItemId);

    if (state.blockedCurrentCreative) {
      state.armed = false;
      clearTimer(slot);
    }
  });

  // Actuele zichtbaarheid bijhouden; na verstreken 30 sec mag terugscrollen alsnog refreshen
  pubads.addEventListener('slotVisibilityChanged', (event) => {
    const { slot } = event;
    const state = getState(slot);

    state.inViewPercentage = event.inViewPercentage;

    if (
      state.armed
      && Date.now() >= state.eligibleAt
      && document.visibilityState === 'visible'
      && state.inViewPercentage >= CONFIG.minInViewPercentage
    ) {
      attemptRefresh(slot);
    }
  });

  // Start van de 30-secondenklok
  pubads.addEventListener('impressionViewable', (event) => {
    const { slot } = event;
    const state = getState(slot);

    if (state.blockedCurrentCreative || state.refreshCount >= CONFIG.maxRefreshesPerSlot) {
      return;
    }

    state.inViewPercentage = Math.max(state.inViewPercentage, CONFIG.minInViewPercentage);
    state.armed = true;
    state.eligibleAt = Date.now() + CONFIG.intervalMs;

    scheduleAttempt(slot, CONFIG.intervalMs);
  });

  // Tab weer actief: wachtende slots opnieuw beoordelen
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') {
      return;
    }

    states.forEach((state, slot) => {
      if (state.armed) {
        attemptRefresh(slot);
      }
    });
  });

  window.gardenersworldAdRefresh = {
    config: CONFIG,

    status() {
      return pubads.getSlots().map((slot) => {
        const state = getState(slot);

        return {
          slot: slotName(slot),
          adUnitPath: slot.getAdUnitPath(),
          refreshCount: state.refreshCount,
          inViewPercentage: state.inViewPercentage,
          armed: state.armed,
          eligibleInSeconds: state.armed
            ? Math.max(0, Math.ceil((state.eligibleAt - Date.now()) / 1000))
            : null,
          currentLineItemId: state.currentLineItemId,
          blockedCurrentCreative: state.blockedCurrentCreative,
        };
      });
    },
  };
}

function loadAds() {
  const mainAd = 'gardenersworld';

  const topArray = ['/page.php', '/single-planten.php', '/single.php', '/home.php', '/archive.php'];
  const mid1Array = ['/single-planten.php', '/single.php', '/page.php'];
  const mid2Array = ['/single-planten.php', '/single.php', '/page.php'];
  const mid3Array = ['/single-planten.php'];
  const isDetailPage = window.currentTemplate.includes('/single') ? '/detail' : '';

  // Wait for googletag to be fully initialized
  googletag.cmd.push(() => {
    // Ensure googletag is properly initialized
    if (typeof googletag.sizeMapping !== 'function') {
      console.error('googletag.sizeMapping is not available');
      return;
    }

    const mappingBillboard = googletag.sizeMapping()
      .addSize([1200, 0], [[970, 250], [728, 90]])
      .addSize([0, 0], [])
      .build();

    const mappingRectangle = googletag.sizeMapping()
      .addSize([1200, 0], [[300, 600], [300, 250]])
      .addSize([728, 0], [[728, 90], [300, 250], [320, 240], [336, 280], 'fluid'])
      .addSize([320, 0], [[320, 240], [300, 250], [360, 640], 'fluid'])
      .build();

    const mappingRectangleMobile = googletag.sizeMapping()
      .addSize([1200, 0], [])
      .addSize([728, 0], [[320, 240], [300, 250], [480, 640]])
      .addSize([320, 0], [[320, 240], [300, 250]])
      .build();


    const mappingRectangleDesktop = googletag.sizeMapping()
      .addSize([1200, 0], [[300, 600], [320, 240], [300, 250], [480, 640]])
      .addSize([728, 0], [])
      .addSize([320, 0], [])
      .build();

    const mappingFluid = googletag.sizeMapping()
      .addSize([1200, 0], [[640, 360], 'fluid'])
      .addSize([728, 0], [[640, 360], 'fluid'])
      .addSize([320, 0], [[640, 360], 'fluid'])
      .build();

    /*
    defineSlot('/123456789/foodiesmag/recepten') for overview page
    defineSlot('/123456789/foodiesmag/recepten/detail') for detail page
    */

    console.log(window);

    // Function to initialize ads after GPT is loaded
    if (topArray.includes(window.currentTemplate)) {
      googletag.defineSlot(`/${window.dfpID}/${mainAd}/${window.postType}/${window.category}${isDetailPage}`, [[970, 250], [728, 90]], 'top')
        .setTargeting('pos', ['top'])
        .defineSizeMapping(mappingBillboard)
        .addService(googletag.pubads());

      googletag.defineSlot(`/${window.dfpID}/${mainAd}/${window.postType}/${window.category}${isDetailPage}`, [[320, 240], [300, 250], [480, 640]], 'top_mobile')
        .setTargeting('pos', ['top'])
        .defineSizeMapping(mappingRectangleMobile)
        .addService(googletag.pubads());
    }

    if (mid1Array.includes(window.currentTemplate)) {
      googletag.defineSlot(`/${window.dfpID}/${mainAd}/${window.postType}/${window.category}${isDetailPage}`, [[320, 240], [320, 100], [300, 250], [480, 640], [728, 90], [336, 280], [300, 600], 'fluid'], 'mid1')
        .setTargeting('pos', ['mid1'])
        .defineSizeMapping(mappingRectangleDesktop)
        .addService(googletag.pubads());
    }

    if (mid2Array.includes(window.currentTemplate)) {
      googletag.defineSlot(`/${window.dfpID}/${mainAd}/${window.postType}/${window.category}${isDetailPage}`, [[320, 240], [320, 100], [300, 250], [480, 640], [728, 90], [336, 280], [300, 600]], 'mid2')
        .setTargeting('pos', ['mid2'])
        .defineSizeMapping(mappingRectangleDesktop)
        .addService(googletag.pubads());
    }

    if (mid3Array.includes(window.currentTemplate)) {
      googletag.defineSlot(`/${window.dfpID}/${mainAd}/${window.postType}/${window.category}${isDetailPage}`, [[640, 360], 'fluid'], 'mid3')
        .setTargeting('pos', ['mid3'])
        .defineSizeMapping(mappingFluid)
        .addService(googletag.pubads());
    }

    if (window.currentTemplate === '/single-planten.php') {
      googletag.pubads().setTargeting('kenmerken', window.adTargeting?.kenmerken ?? []);
      googletag.pubads().setTargeting('planttypes', window.adTargeting?.planttypes ?? []);
    }

    googletag.pubads().enableSingleRequest();
    googletag.pubads().setTargeting('pagetype', ['detail']);
    googletag.pubads().collapseEmptyDivs();
    googletag.pubads().setCentering(true);
    googletag.enableServices();

    if (topArray.includes(window.currentTemplate) && document.getElementById('top')) {
      googletag.display('top');

      if (document.getElementById('top_mobile')) {
        googletag.display('top_mobile');
      }
    }

    if (mid1Array.includes(window.currentTemplate) && document.getElementById('mid1')) {
      googletag.display('mid1');
    }

    if (mid2Array.includes(window.currentTemplate) && document.getElementById('mid2')) {
      googletag.display('mid2');
    }
    if (mid3Array.includes(window.currentTemplate) && document.getElementById('mid3')) {
      googletag.display('mid3');
    }
  });

  /* eslint-enable no-undef */
}
